module.exports = __webpack_public_path__ + "images/branding/loan_review/logo.gif";